module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/align-center-bf8381f5690eea99acf8ad2caaae3dd1.svg";